// ** Redux Imports
import auth from "./auth";
import admin from "./admin";
import user from "./users";
import instructor from "./instructors";
import course from "./courses";
import module from "./modules";
import lesson from "./lessons";
import tag from "./tags";
import category from "./categories";
import partner from "./partner";
import corporate from "./corporate";
import corporateUser from "./corporateUser";
import payment from "./payments";
import quiz from "./quizzes";
import enrollment from "./enrollment";
import promotion from "./promotion/course";
import bookPromotion from "./promotion/book";
import subscriptionPromotion from "./promotion/subscription";
import couponCode from "./promotion/couponCode";
import extension from "./extension";
import comment from "./comment";
import faqs from "./faqs";
import blog from "./blog";
import book from "./book";
import subscription from "./subscription";
import subscribe from "./subscribe";
import bookOrder from "./bookOrder";
import notifications from "./notifications";
import appConfig from "./appConfig";
import thankyou from "./thankyou";
import event from "./event";
import { combineReducers } from "redux";
import eventRegistration from "./eventRegistration";
import redeemCoin from "./redeemCoin";
import video from "./videos";
const rootReducer = combineReducers({
  auth,
  admin,
  user,
  instructor,
  course,
  blog,
  book,
  bookOrder,
  bookPromotion,
  couponCode,
  subscriptionPromotion,
  subscribe,
  subscription,
  module,
  lesson,
  tag,
  category,
  partner,
  corporate,
  corporateUser,
  enrollment,
  payment,
  quiz,
  promotion,
  extension,
  comment,
  faqs,
  notifications,
  appConfig,
  thankyou,
  event,
  eventRegistration,
  redeemCoin,
  video
});

export default rootReducer;
